export const sortPreferencesByPrice = {
  priority: 1,
  type: 'PRICE',
  sliceRefId: 1,
  order: 'ASC',
}

export const sortPreferencesByTravelTime = [
  {
    priority: 1,
    type: 'TRAVELTIME',
    sliceRefId: -1,
    order: 'ASC',
  },
  {
    priority: 1,
    type: 'TRAVELTIME',
    sliceRefId: 1,
    order: 'ASC',
  },
]

export const sortPreferencesByDepartTime = ({ numOfSlices = 1 }) => {
  const departTimeSortPrefs = []
  for (let i = 1; i <= numOfSlices; i++) {
    departTimeSortPrefs.push({
      priority: 1,
      type: 'DEPARTTIME',
      sliceRefId: i,
      order: 'ASC',
    })
  }

  return departTimeSortPrefs
}

export function getCabinClass({ cabinClass }) {
  return cabinClass
}

export function getItineraryType(tripType) {
  const itineraryType = {
    OW: 'ONE_WAY',
    RT: 'ROUND_TRIP',
    MD: 'MULTI_DESTINATION',
  }

  return itineraryType[tripType]
}

//  TODO: move to it's own util function
export function getPassengerInfo({ params }) {
  const { adults, children, infants } = buildPassengerInfo({ params })

  return {
    adults,
    children,
    infants,
  }
}

export function buildPassengerInfo({ params }) {
  return {
    adults: getNumOfPassengers(params['num-adults']) || 1,
    children: getNumOfPassengers(params['num-children']) || 0,
    infants: getNumOfPassengers(params['num-infants']) || 0,
  }
}

export function getNumOfPassengers(passengerType) {
  if (passengerType && !isNaN(Number(passengerType))) {
    return Number(passengerType)
  }

  return 0
}
